module.exports = __webpack_public_path__ + "static/media/charlesbeaumont.1a9f92d8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/charlesbeaumont.webp
// module id = 849
// module chunks = 0